/**
 * @desc 查询铁质材料需求年计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanYearFerrousMaterialResponse>> {
  return defHttp.post({
    url: '/wap/plan/year/queryPlanFerrousMaterial',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanYearFerrousMaterialResponse>> {
  return defHttp.post({
    url: '/mock/wap/plan/year/queryPlanFerrousMaterial',
    data,
  });
}
